import { useState, useEffect, useRef } from "react";

export const useTeacherFilters = (onFilterChange) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [employmentStatusFilter, setEmploymentStatusFilter] = useState("");
  const [activeFilter, setActiveFilter] = useState("");
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    const timeoutId = setTimeout(() => {
      const filters = {
        ...(searchTerm && { search: searchTerm }),
        ...(employmentStatusFilter && { employment_status: employmentStatusFilter }),
        ...(activeFilter !== "" && { is_active: activeFilter }),
      };
      onFilterChange(filters);
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [searchTerm, employmentStatusFilter, activeFilter, onFilterChange]);

  const clearFilters = () => {
    setSearchTerm("");
    setEmploymentStatusFilter("");
    setActiveFilter("");
  };

  const hasActiveFilters = () => {
    return searchTerm || employmentStatusFilter || activeFilter;
  };

  return {
    searchTerm,
    setSearchTerm,
    employmentStatusFilter,
    setEmploymentStatusFilter,
    activeFilter,
    setActiveFilter,
    clearFilters,
    hasActiveFilters,
  };
};
